
import './App.css';
import EligibilityCheck from './components/Eligibility_check';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/landingpage';
import { ThemeProvider, createTheme } from '@mui/material';
import Header from './components/Header';
// import Footer from './components/Footer';

const theme = createTheme({
  // Customize your theme here
});

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
      <Header />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/check-eligibility" element={<EligibilityCheck />} />
        </Routes>
        
      </BrowserRouter>
      </ThemeProvider>
      


    
   
  );
};

export default App;

